import { generateRoutePath } from './generatePath';

const reservationBase = '/varaus';

export const Paths: Record<string, string> = {
  Home: '/',
  Help: '/tuki',
  HelpCategory: '/tuki/:slug',
  RobotsTxt: '/robots.txt',
  Sitemap: '/sitemap.xml',
  Memory: '/matkat/:slug',
  MemoryList: '/matkat',
  Destination: '/golfkentat/:slug',
  DestinationList: '/golfkentat',
  Reservation: reservationBase,
  CreateReservation: reservationBase + '#/createReservation',
  SearchResults: '/suositukset',
  Traveller: '/matkaajat/:slug',
  TravellerList: '/matkaajat',
  Country: '/kaupungit/:slug',
  CountryList: '/kaupungit'
};

const slug = { slug: '[slug]' };
export const RoutePathsForPaths = {
  [Paths.Home]: generateRoutePath(Paths.Home),
  [Paths.Help]: generateRoutePath(Paths.Help),
  [Paths.HelpCategory]: generateRoutePath(Paths.HelpCategory, slug),
  [Paths.RobotsTxt]: generateRoutePath(Paths.RobotsTxt),
  [Paths.Sitemap]: generateRoutePath(Paths.Sitemap),
  [Paths.Destination]: generateRoutePath(Paths.Destination, slug),
  [Paths.DestinationList]: generateRoutePath(Paths.DestinationList),
  [Paths.Memory]: generateRoutePath(Paths.Memory, slug),
  [Paths.MemoryList]: generateRoutePath(Paths.MemoryList),
  [Paths.Reservation]: generateRoutePath(Paths.Reservation),
  [Paths.CreateReservation]: generateRoutePath(Paths.CreateReservation),
  [Paths.SearchResults]: generateRoutePath(Paths.SearchResults),

  [Paths.TravellerList]: generateRoutePath(Paths.TravellerList),
  [Paths.Country]: generateRoutePath(Paths.Country, slug),
  [Paths.CountryList]: generateRoutePath(Paths.CountryList)
};
